import {
    HELP_MAIN_SUCCESS,
    HELP_MAIN,
    HELP_MAIN_FAIL,
} from './constants';

//
export const HelpMainReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case HELP_MAIN:
            ret.loading = true;
            ret.loadSuccess = null;
            ret.loadDatas = null;
            break;
        case HELP_MAIN_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.loadDatas = data.loadDatas;
            break;
        case HELP_MAIN_FAIL:
            ret.loading = false;
            ret.loadSuccess = false;
            ret.error = data;
            break;
        default:
            return {...state};
    }
    return ret;
}
